import { DateTime } from 'luxon'

export function encodeSymbols (message) {
  message = message.split(/\n/g).join('%0d%0a')
  message = message.split(/\./g).join('%2E')
  message = message.split(/&/g).join('%26')
  message = message.split(/\?/g).join('%3F')
  message = message.split(/#/g).join('%23')
  message = message.split(/</g).join('%3C')
  message = message.split(/>/g).join('%3E')
  return message
}

export function convertToAvatarName (value) {
  if (!value) { return '' }
  if (value.includes(' ') > -1) {
    return value.substring(0, 1).toUpperCase() + value.substring(value.includes(' ') + 1).substring(0, 1).toUpperCase()
  }
  return value.substring(0, 2).toUpperCase()
}

export function convertServerDate (value) {
  const current = new Date()
  const previous = DateTime.fromISO(value)
  const msPerMinute = 60 * 1000
  const msPerHour = msPerMinute * 60
  const msPerDay = msPerHour * 24
  const msPerWeek = msPerDay * 6
  const msPerMonth = msPerDay * 30
  const msPerYear = msPerDay * 365

  const elapsed = current - previous

  if (elapsed < msPerMinute) {
    if (Math.round(elapsed / 1000) === 0) {
      return 'Just now'
    }
    if (Math.round(elapsed / 1000) === 1) {
      return '1 second ago'
    }
    return Math.round(elapsed / 1000) + ' seconds ago'
  } else if (elapsed < msPerHour) {
    if (elapsed / msPerMinute < 2) {
      return 'A minute ago'
    }
    return Math.round(elapsed / msPerMinute) + ' minutes ago'
  } else if (elapsed < msPerDay) {
    if (elapsed / msPerHour < 2) {
      return 'An hour ago'
    }
    return Math.round(elapsed / msPerHour) + ' hours ago'
  } else if (elapsed > msPerWeek && elapsed < msPerMonth) {
    if (
      Math.round(elapsed / msPerMonth) === 1 &&
      Math.round(elapsed / msPerWeek) === 5
    ) {
      return 'Last month'
    } else if (elapsed / msPerWeek < 2) {
      return 'Last week'
    }
    return Math.round(elapsed / msPerWeek) + ' weeks ago'
  } else if (elapsed < msPerMonth) {
    if (elapsed / msPerDay < 2) {
      return 'Yesterday'
    }
    return Math.round(elapsed / msPerDay) + ' days ago'
  } else if (elapsed < msPerYear) {
    if (elapsed / msPerMonth < 2) {
      return 'Last month'
    }
    return Math.round(elapsed / msPerMonth) + ' months ago'
  }
  return new Date(previous.toMillis()).toDateString()
}
